import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

import { AuthenticationService } from 'src/app/core/authentication.service';
import { NotificationService } from 'src/app/core/notification.service';
import { ApplicationFeedback } from 'src/app/shared/interfaces/api-response';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {

  loginForm = new FormGroup({
    username: new FormControl<string>("", { nonNullable: true }),
    password: new FormControl<string>("", { nonNullable: true })
  })
  loginInProgress = false

  constructor(private authentication: AuthenticationService,
              private notificationService: NotificationService,
              private router: Router) { }

  async login() {
    this.loginInProgress = true
    const response: ApplicationFeedback = await this.authentication.login(
      this.getFieldValue(this.loginForm.value.username),
      this.getFieldValue(this.loginForm.value.password),
    )

    this.loginInProgress = false
    if (response.success) {
      this.router.navigateByUrl('/home')
      this.notificationService.displaySuccess('Hello ' + this.loginForm.value.username)
    }
    else {
      this.notificationService.displayError(response.message);
    }
  }

  getFieldValue(field: string | undefined) {
    if (field) {
      return field
    }
    return ""
  }
}
